// Clark University's undergraduate majors (#2743). Read on 2026-10-01 from
// the official 2026-2027 Academic Catalog's Programs of Study page
// (catalog.clarku.edu, catoid=37), whose "Undergraduate Major" list names 40
// majors with no degree type (the program pages state one only here and
// there), so `degree` is null throughout and the list is one group, as the
// catalog gives it. The trailing word "Major" is dropped from each name
// except "Student-Designed Major", which needs it; the curly apostrophe in
// "Women's" is typed straight.
// Left out: minors, concentrations, the 4+1 accelerated master's programs,
// graduate programs, certificates, and the eight School of Professional
// Studies majors (Biotechnology BS ... General Studies BGS), which Clark
// describes as degree completion programs "intended for applicants who have
// previous college experience" (SPS Undergraduate Degree Completion Programs
// page), not first-year entry.
// Flag for the coordinator: the official name "Business Analytics and
// Applied AI" contains the word AI; it is kept as the catalog writes it.
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "clark-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Clark's official 2026-2027 Academic Catalog. The catalog lists the majors without a degree type, so none is shown. Minors, concentrations, accelerated master's programs and the School of Professional Studies' degree completion programs are left out.",
    "groups": [
        {
            "name": "Clark University",
            "source": {
                "label": "Clark 2026-2027 Academic Catalog, Programs of Study",
                "url": "https://catalog.clarku.edu/content.php?catoid=37&navoid=2906"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Business Administration",
                    "degree": null
                },
                {
                    "name": "Business Analytics and Applied AI",
                    "degree": null
                },
                {
                    "name": "Business Economics",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Climate, Environment, and Society",
                    "degree": null
                },
                {
                    "name": "Combined Languages",
                    "degree": null
                },
                {
                    "name": "Community, Youth, and Education Studies",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Creative Writing",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Health, Science & Society",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Interactive Media",
                    "degree": null
                },
                {
                    "name": "International Development and Social Change",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Mathematics Education",
                    "degree": null
                },
                {
                    "name": "Media, Culture and the Arts",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Screen Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Student-Designed Major",
                    "degree": null
                },
                {
                    "name": "Theater Arts",
                    "degree": null
                },
                {
                    "name": "Visual Arts",
                    "degree": null
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
